import React, { cloneElement } from 'react';
import classNames from 'classnames';
import { useStyles } from './iconLink.styles';
import LoadingSpinner from '../LoadingSpinner';
import Typography from '../Typography';
function IconLink({ children, className, onClick, loading, disabled, selected, size = 'large', icon, }) {
    const classes = useStyles();
    const Icon = cloneElement(icon, {
        className: classNames(classes.icon, {
            [classes.selectedIcon]: selected,
            [classes.disabledIcon]: disabled || loading,
        }),
    });
    const Text = cloneElement(children, {
        className: classes.text,
    });
    return (React.createElement("div", { className: classNames(className, classes.iconLinkRoot) },
        React.createElement("button", { className: classNames(classes.button, classes[size], {
                [classes.selected]: selected,
            }), onClick: onClick, disabled: disabled || loading },
            React.createElement("div", { className: classes.iconWrapper },
                loading && (React.createElement("div", { className: classes.loaderContainer },
                    React.createElement(LoadingSpinner, null))),
                Icon)),
        React.createElement(Typography, { variant: "body2", className: classNames(classes.text, {
                [classes.disabledText]: disabled || loading,
                [classes.selectedText]: selected,
            }) }, Text)));
}
export default IconLink;
//# sourceMappingURL=IconLink.js.map